/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewZoomyDomainConfidenceMapScoreItem } from './CRSFSecReviewZoomyDomainConfidenceMapScoreItem';
import {
    CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSON,
    CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSONTyped,
    CRSFSecReviewZoomyDomainConfidenceMapScoreItemToJSON,
} from './CRSFSecReviewZoomyDomainConfidenceMapScoreItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewZoomyDomainConfidenceMapScore
 */
export interface CRSFSecReviewZoomyDomainConfidenceMapScore {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScore
     */
    confidence: number;
    /**
     * 
     * @type {CRSFSecReviewZoomyDomainConfidenceMapScoreItem}
     * @memberof CRSFSecReviewZoomyDomainConfidenceMapScore
     */
    detailed_score: CRSFSecReviewZoomyDomainConfidenceMapScoreItem;
}

/**
 * Check if a given object implements the CRSFSecReviewZoomyDomainConfidenceMapScore interface.
 */
export function instanceOfCRSFSecReviewZoomyDomainConfidenceMapScore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidence" in value;
    isInstance = isInstance && "detailed_score" in value;

    return isInstance;
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSON(json: any): CRSFSecReviewZoomyDomainConfidenceMapScore {
    return CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSONTyped(json, false);
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewZoomyDomainConfidenceMapScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidence': json['confidence'],
        'detailed_score': CRSFSecReviewZoomyDomainConfidenceMapScoreItemFromJSON(json['detailed_score']),
    };
}

export function CRSFSecReviewZoomyDomainConfidenceMapScoreToJSON(value?: CRSFSecReviewZoomyDomainConfidenceMapScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence': value.confidence,
        'detailed_score': CRSFSecReviewZoomyDomainConfidenceMapScoreItemToJSON(value.detailed_score),
    };
}

